import React from "react";
import { Link } from "gatsby";
import { css } from "glamor";

export default ({ ...props }) => (
  <Link to={props.pathFr} {...cssSubLink}>
    <span role="img" aria-label="French flag - Drapeau français">
      🇫🇷
    </span>{" "}
    Version française
  </Link>
);

const cssSubLink = css({
  display: `block`,
  padding: `0.6em 0 .7em .6em`,
  fontWeight: `500`,
  color: `white`,
  textDecoration: `none`,
  letterSpacing: `0.02em`,
  ":hover": {
    opacity: `.98`
  }
});
